import { property as a } from "lit/decorators.js";
import { SpectrumElement as f } from "@spectrum-web-components/core/shared/base/index.js";
var i = Object.defineProperty, l = (r, p, o, m) => {
  for (var e = void 0, t = r.length - 1, s; t >= 0; t--)
    (s = r[t]) && (e = s(p, o, e) || e);
  return e && i(p, o, e), e;
};
class n extends f {
  constructor() {
    super(...arguments), this.label = "";
  }
}
l([
  a({ type: String, reflect: !0 })
], n.prototype, "variant");
l([
  a()
], n.prototype, "label");
export {
  n as AssetBase
};
//# sourceMappingURL=Asset.base.js.map
